import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Popover from '@material-ui/core/Popover';
// Shared components
import Paper from 'components/Paper';
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletContent from 'components/PortletContent';
import PortletLabel from 'components/PortletLabel';
import PortletFooter from 'components/PortletFooter';
import Period from '../../../../helpers/PeriodWeighted';
import {getSpecialMethod} from '../../../../services/specials/getSpecial'
import ReportLegacy from './ReportLegacy'
import WaitServer from '../../../../utils/WaitServer'
import Error from '../../../../utils/Error'
import Filter from '../../../../helpers/Filter'
import { Grid } from '@material-ui/core';
import queryString from 'query-string';

// Component styles
import styles from './styles';

import moment from 'moment-timezone'
import 'moment/locale/es'
import { Typography } from '@material-ui/core';
import { isUndefined } from 'underscore';
moment.locale('es')

export function getDefaultPeriod() {
  
  const selectedGlobalPeriod = sessionStorage.getItem("statePeriodo");
  //console.log({selectedGlobalPeriod})
  const parseSelectedGlobalPeriod = selectedGlobalPeriod
    ? JSON.parse(selectedGlobalPeriod)
    : null;
  if (parseSelectedGlobalPeriod) {
    parseSelectedGlobalPeriod.statePeriod.startDate = new Date(
      parseSelectedGlobalPeriod.statePeriod.startDate
    );
    parseSelectedGlobalPeriod.statePeriod.endDate = new Date(
      parseSelectedGlobalPeriod.statePeriod.endDate
    );
  }
  sessionStorage.removeItem("statePeriodo")
  return parseSelectedGlobalPeriod;
}

class Legacy extends Component {
  constructor(props) {
    super(props);
    const periodDefaultStorage = getDefaultPeriod()

    var configSpecial=JSON.parse(sessionStorage.getItem("objetivoConfigSpecial"))
    var setupSpecial=JSON.parse(sessionStorage.getItem("setupSpecial"))
    var scheduleSpecial=JSON.parse(sessionStorage.getItem("scheduleSpecial"))
    var typesSpecial=JSON.parse(sessionStorage.getItem("typesSpecial"))
    var esPdf=true
    var esWord=true
    var esCsv=false
    //console.log(typesSpecial.filter(i=>i["content-type"]==="pdf").length)
    if((typesSpecial.filter(i=>i["content-type"]==="pdf")).length===0){
      esPdf=false
    }
    if((typesSpecial.filter(i=>i["content-type"]==="doc")).length===0){
      esWord=false
    }
    if((typesSpecial.filter(i=>i["content-type"]==="xls")).length>0||(typesSpecial.filter(i=>i["content-type"]==="csv")).length>0){
      esCsv=true
    }
    //console.log(esPdf)
    var schedule=false
    var objButton=false
    var periodButton=false
    var reportBoolean=false
    var listObjs=[]
    var scheduleList=[]
    var interval="interval"
    var period="d"
    var range='Rango: último día'
    if(scheduleSpecial.length>0 && scheduleSpecial[0].selector==="true"){
      schedule=true
      scheduleList=JSON.parse(sessionStorage.getItem("horarios"))
    }
    if(typeof(configSpecial.selector)!=="undefined" && configSpecial.selector==="true"){
      objButton=true
      listObjs=JSON.parse(sessionStorage.getItem("objetivosSpecial"))
    }else{
      listObjs = [{id:this.props.data.match.params.objetivo_id}]
    }
    if (listObjs.length ==0){
      listObjs = [{id:this.props.data.match.params.objetivo_id}]
    }
    if(typeof(setupSpecial.date_selection)!=="undefined" && (setupSpecial.date_selection==="interval"||setupSpecial.date_selection==="day")){
      periodButton=true
      interval=setupSpecial.date_selection
    }
    let defaultPeriod = {}
    //console.log(JSON.parse(sessionStorage.getItem("setupSpecial")).lista_informes.length)
    var reportListBoolean = JSON.parse(sessionStorage.getItem("setupSpecial")).report_list;
    if(JSON.parse(sessionStorage.getItem("setupSpecial")).lista_informes.length>0){
      reportBoolean=true
      periodButton=true
      period="c"
      range='Rango: último Mes'

      /** Setear fecha por defecto */
      const startDate = moment().subtract({"months":1}).startOf('month')
      let month = startDate.month() + 1
      let year = startDate.year()
      
      const parsedQuertSearch = queryString.parse(this.props.data.location.search)
      if (parsedQuertSearch) {
          month = parsedQuertSearch?.month ?? month
          year = parsedQuertSearch?.year ?? year
      }
      defaultPeriod = {
        endDate: `${year}-${month}-${moment(`${year}-${month}-01`).daysInMonth()}`,
        startDate: `${year}-${month}-01`,
        key: 'selection'
      }
    }
    //console.log('legacy', reportBoolean)
    this.handleInfoAutoComplete = this.handleInfoAutoComplete.bind(this);
    this.state = {
        nameObjective: this.props.data.match.params.nombre_objetivo,
        objective:this.props.data.match.params.objetivo_id,
        method:this.props.method,
        error:false,
        load:true,
        period:periodDefaultStorage?.period??period,
        typePeriod:periodDefaultStorage?.typePeriod??1,
        namePeriod:periodDefaultStorage?.namePeriod??range,
        statePeriod: periodDefaultStorage?.statePeriod??defaultPeriod,
        periodEl: null,
        objButton:objButton,
        periodButton:periodButton,
        listObjs:listObjs,
        objChild:listObjs[0],
        schedule:schedule,
        scheduleList:scheduleList,
        scheduleName:{"horario_id":0,"nombre":"Todo Horario"},
        listReport:JSON.parse(sessionStorage.getItem("setupSpecial")).lista_informes,
        reportBoolean:reportBoolean,
        reportListBoolean: reportListBoolean,
        indexReport:0,
        report:[],
        esPdf:esPdf,
        interval:interval,
        esWord:esWord,
        esCsv:esCsv
    }
  }

  

  componentDidMount() {
    this.getSpecial()
  }
  componentDidUpdate(prevProps, prevState) {
    
    //console.log(prevState.period, this.state.period)
    if(JSON.parse(sessionStorage.getItem("setupSpecial")).lista_informes.length>0){
      if(JSON.parse(sessionStorage.getItem("setupSpecial")).lista_informes[prevState.indexReport].nombre!==this.state.listReport[this.state.indexReport].nombre){
        //console.log('up')
        this.getSpecial()
      }
    }
    if(prevState.period!==this.state.period){
      this.getSpecial()
    }
  }

  //metodo que llama a proceso de pdf en api
  getSpecial =()=>{
    const {objective, objChild, nameObjective, scheduleName, listReport, indexReport, reportBoolean,reportListBoolean,
      objButton, periodButton, period, statePeriod, esPdf, esWord}=this.state
    const token = sessionStorage.getItem('key')
    const user = sessionStorage.getItem('user')
    const method=sessionStorage.getItem("methodSpecial")
    var scheduleId=scheduleName.horario_id
    const acentos = {'á':'a','é':'e','í':'i','ó':'o','ú':'u','Á':'A','É':'E','Í':'I','Ó':'O','Ú':'U'};
	  var name= nameObjective.split('').map( letra => acentos[letra] || letra).join('').toString()
    var args=[name, scheduleId]
    if(esPdf===true){
      if(esWord===true){
        this.setState({
          report: [],
          load:false
        });
      }else{
        if(objButton===true){
          args.push(objChild.id)
        }
        //console.log(periodButton, period, reportBoolean)
        if(periodButton===true){
          //console.log('period', period, statePeriod)
          var begin=moment().tz(sessionStorage.getItem('tz')).subtract({"days":1})
          var final=moment().tz(sessionStorage.getItem('tz'))
          if(period==="3d"){
            begin=moment().subtract({"days":3})
          }
          if(period==="w"){
            begin=moment().subtract({"days":7})
          }
          if(period==="c"){
            if(reportListBoolean === "true"){
              if(reportBoolean === true){
                begin=moment().subtract({"months":1}).startOf('month')
                final=moment().subtract({"months":1}).endOf('month')
              }else{
                begin=moment(statePeriod.startDate)
                final=moment(statePeriod.endDate).add({'days':1})
              }
            }
          }
          //console.log(begin, final)
          args.push('&esPeriod=1'+'&inicio='+String(begin.format("YYYY-MM-DD"))+'&termino='+String(final.format("YYYY-MM-DD")))
        }
        if(reportBoolean===true){
          args.push('&esReport='+listReport[indexReport].nombre)
        }
        if(esWord===true){
          args.push('&word=1')
        }
        args=args.toString()
        
        this.setState({
          report: 'report',
          load:false
        });
      }
    }else{
      this.setState({
        report: [],
        load:false
      });
    }
    
  }

  handleInfoAutoComplete(tag, info) {
    if(tag==="Horarios"){
      this.setState({
        scheduleName: info,
      });
    }
    if(tag==="Monitoreos"){
      this.setState({
        objChild: info,
      });
    }
  }

  handlePeriodClick=(prevPeriod, prevTypeGraph, statePeriod, nextPeriod)=> {
    if (nextPeriod === 'dia') {
        this.setState({
            period: "d",
            typePeriod: 1,
            namePeriod: 'Rango: último día',
            statePeriod: {},
            periodEl: null,
        });
      sessionStorage.setItem("statePeriodo",JSON.stringify({period: "d",typePeriod: 1,namePeriod: 'Rango: último día',statePeriod: {}}))

    } else if (nextPeriod === '3dia') {
        this.setState({
            period: "3d",
            typePeriod: 5,
            namePeriod: 'Rango: últimos 3 días',
            statePeriod: {},
            periodEl: null,
        });
      sessionStorage.setItem("statePeriodo",JSON.stringify({period: "3d",typePeriod: 5,namePeriod: 'Rango: últimos 3 días',statePeriod: {}}))

    } else if (nextPeriod === 'semana') {
        this.setState({
            period: "w",
            typePeriod: 2,
            namePeriod: 'Rango: última semana',
            statePeriod: {},
            periodEl: null,
        });
      sessionStorage.setItem("statePeriodo",JSON.stringify({period: "w",typePeriod: 2,namePeriod: 'Rango: última semana',statePeriod: {}}))
    } else if (nextPeriod === 'custom') {
        var date = 'Rango: ' + moment(statePeriod.startDate).format("YYYY-MM-DD") + ' a ' + moment(statePeriod.endDate).format("YYYY-MM-DD")
        this.setState({
            period: "c",
            typePeriod: 3,
            namePeriod: date,
            statePeriod: statePeriod,
            periodEl: null,            
        });
        sessionStorage.setItem("statePeriodo",JSON.stringify({period: "c",typePeriod: 3,namePeriod: date, statePeriod}))

        const year = moment(statePeriod.startDate).year()
        const month = moment(statePeriod.startDate).month() + 1
        const objetivoId = this.props.data.match.params.objetivo_id
        const nameObjective = this.props.data.match.params.nombre_objetivo
        this.props.data.history.push({pathname: `/especial/${objetivoId}/${nameObjective}`, search: `?year=${year}&month=${month}`})
    }
  }
  handleShowPeriod = event => {
    this.setState({
        periodEl: event.currentTarget
    });
  };

  handleClosePeriod = () => {
    this.setState({
        periodEl: null
    });
  };

  changeReport=(index)=>{
    //console.log('changeReport')
    this.setState({
      indexReport: index
    });
  }
  

  createReport=(ele, i)=>{
    const {indexReport}=this.state
    var color="white"
    var textColor="#bfbfbf"
    if(indexReport===i){
      color="#bfbfbf"
      textColor="white"
    }
    return(<Grid
            key={ele.nombre}
            item
            xs={2}
            sm={2}
            md={2}
            xl={2}
            
          >
            <Button style={{backgroundColor:color, left:"-10px"}} onClick={this.changeReport.bind(this, i)}>
              <Typography style={{fontSize:"10px", color:textColor}} variant="h6">{ele.nombre}</Typography>
            </Button>
          </Grid>
    )
  }
  

  render() {
    const { classes, className, ...rest } = this.props;
    const {periodEl, period, namePeriod, nameObjective, periodButton, objButton, listObjs, objChild, objective, load, error, report, 
      schedule, scheduleList, scheduleName, listReport, reportBoolean,reportListBoolean, indexReport, esPdf, statePeriod, interval, esWord, esCsv}=this.state
    const showPeriodEl = Boolean(periodEl);
    
    if(load===true){
      return (
        <PortletContent style={{height:"100%", backgroundColor:"white"}}>
          <WaitServer />
        </PortletContent>
      )
    }else if(error===true){
      return(
        <PortletContent style={{height:"100%"}}>
          <Error />
        </PortletContent>
      )
      
    }else{
      return (
        <Portlet
          style={{width:"95%"}}
        >
          <PortletHeader style={{height:"auto", paddingTop: "10px", paddingBottom: "10px"}} >
            
            <Grid
              container
              spacing={1}
              alignItems="center"
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                xl={4}
              >
                <Typography variant="h3" style={{ color:'#66788A'}}  >{nameObjective}</Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={2}
                xl={2}
                alignItems="center"
              >
                {(reportListBoolean === "true"?
                  (reportBoolean === true?
                    <Grid
                    container
                    spacing={9}
                    >
                      {listReport.map((ele, i)=>(
                        this.createReport(ele,i)
                      ))}
                    </Grid>
                    :<Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                      >
                      <Typography style={{color:'#66788A'}} variant="h4">No hay informes disponibles</Typography>
                    </Grid>)
                :null)}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={2}
                xl={2}
              >
                
                <Button  style={{fontSize:'15px',float:'left', color:'#66788A'}} onClick={this.handleShowPeriod}>
                  {namePeriod}<ArrowDropDownIcon />
                </Button>
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={2}
                xl={2}
              >
                {schedule?
                  <Filter list={scheduleList} label="Horarios" placeholder="Filtro de Horarios" InfoAutoComplete={this.handleInfoAutoComplete}/>
                :null}
              </Grid>
              {objButton?
              <Grid
                item
                xs={6}
                sm={6}
                md={2}
                xl={2}
              >
                  <Filter list={listObjs} label="Monitoreos" placeholder="Filtro de Monitoreo" InfoAutoComplete={this.handleInfoAutoComplete}/>
              </Grid>
              :null}
              
            </Grid>
            
          </PortletHeader>
          <ReportLegacy obj={objChild} pdf={esPdf} parentObj={objective} objButton={objButton} report={report} 
                        reportBoolean={reportBoolean} indexReport={indexReport} listReport={listReport[indexReport]} 
                        scheduleBoolean={schedule} periodBoolean={periodButton} namePeriod={namePeriod} 
                        horario_id={scheduleName.horario_id} nombre_horario={scheduleName.name} state={statePeriod}
                        period={period} word={esWord} esCsv={esCsv}/>
          <PortletFooter>
           
            <Popover
                anchorEl={periodEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                onClose={this.handleClosePeriod}
                open={showPeriodEl}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}>
                <Period onClick={this.handlePeriodClick} period={period} reportBoolean={reportBoolean} interval={interval}/>
            </Popover>
          </PortletFooter>
        </Portlet>
      );
    }
    
  }
}

Legacy.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Legacy);
